import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgPlus = ({ size = "regular", className = "", ...props }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12 2c.473 0 .857.384.857.857v8.286h8.286a.857.857 0 0 1 0 1.714h-8.286v8.286a.857.857 0 0 1-1.714 0v-8.286H2.857a.857.857 0 1 1 0-1.714h8.286V2.857c0-.473.384-.857.857-.857"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgPlus;
